import React from 'react';
import UsersQuotaReportOverviewCard from '../UsersQuotaReportOverviewCard';
import PropTypes from 'prop-types';

import {
  EXTERNAL_ACTIVE_USERS_DESCRIPTION,
  EXTERNAL_ACTIVE_USERS_DESCRIPTION_FOR_MIXED_PLAN,
  DETAILED_REPORT_TYPES as T
} from '../../utils/resources/reports';

export default function ExternalUsersQuotaReportOverviewCard(props) {
  const {
    showReportDetails,
  } = props;

  return (
    <UsersQuotaReportOverviewCard
      {...props}
      usersField="externalUsers"
      title="External Active Users"
      description={EXTERNAL_ACTIVE_USERS_DESCRIPTION}
      descriptionForMixedPlan={EXTERNAL_ACTIVE_USERS_DESCRIPTION_FOR_MIXED_PLAN}
      handleClick={showReportDetails(T.EXTERNAL_ACTIVE_USERS)}
    />
  );
}

ExternalUsersQuotaReportOverviewCard.propTypes = {
  showReportDetails: PropTypes.func
};
